/* eslint-disable no-console */
import { environment } from '@env/environment';
import { Action, ActionReducer, ActionReducerMap, MetaReducer } from '@ngrx/store';
import { favoritesReducer, FavoritesState } from '@store/reducers/favorites.reducer';

import { accountReducer, AccountState } from './account.reducer';
import { documentSubTypesReducer, DocumentSubTypesState } from './document-subtypes.reducer';
import { featureFlagsReducer, FeatureFlagState } from './feature-flags.reducer';
import { historyReducer, HistoryState } from './history.reducer';
import { itemsReducer, ItemsState } from './items.reducer';

export interface AppState {
  items: ItemsState;
  account: AccountState;
  documentSubTypes: DocumentSubTypesState;
  featureFlags: FeatureFlagState;
  favorites: FavoritesState;
  history: HistoryState;
}

/**
 * The root reducer map for the application.
 */
export const reducers: ActionReducerMap<AppState, Action> = {
  items: itemsReducer,
  account: accountReducer,
  documentSubTypes: documentSubTypesReducer,
  featureFlags: featureFlagsReducer,
  favorites: favoritesReducer,
  history: historyReducer,
  // other reducers go here
};

/**
 *  This is a logger used for local development. This can be used in addition to
 * the redux devtools chrome extension
 * @param reducer The reducer currently acting
 */
export function logger(reducer: ActionReducer<AppState>): ActionReducer<AppState> {
  return (state, action) => {
    const result = reducer(state, action);
    console.groupCollapsed(action.type);
    console.log('prev state', state);
    console.log('action', action);
    console.log('next state', result);
    console.groupEnd();

    return result;
  };
}
export const metaReducers: MetaReducer<AppState>[] = !environment.production ? [logger] : [];
